import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 700 700",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M0,0V700H700V0ZM600,600H100V100H600Z" }), /* @__PURE__ */ _jsx("polygon", { points: "550 450 250 450 250 250 450 250 450 350 550 250 550 150 150 150 150 550 550 550" })]
});
export default SvgLogoIcon;
